module.exports = "../logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = ./src/assets/img/logo.png
// module chunks = 2